import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

import { GridBooleanColumnConfig } from '../../../components/paged-grid/models/grid-boolean-column.config';
import { GridColumnConfig } from '../../../components/paged-grid/models/grid-column.config';
import { GridDateColumnConfig } from '../../../components/paged-grid/models/grid-date-column.config';
import { GridNumberColumnConfig } from '../../../components/paged-grid/models/grid-number-column.config';
import { GridConfig } from '../../../components/paged-grid/models/grid.config';
import { ModelTypes } from '../../../core/utils/mappers/model.types';
import { ListGmShareholderModel } from '../../../models/list-gm-shareholder.model';
import { GmShareholdersResource } from '../../../services/resources/gm-shareholders.resource';

@Component({
    selector: 'sl-gm-shareholders',
    templateUrl: './gm-shareholders.component.html',
    styleUrls: ['./gm-shareholders.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GmShareholdersComponent implements OnInit {
    gridConfig: GridConfig<ListGmShareholderModel>;

    private readonly shareholdersResource = inject(GmShareholdersResource);

    ngOnInit(): void {
        const columns = [
            new GridColumnConfig({ fieldName: 'registrationStatusDescription', header: 'GeneralMeeting.Shareholders.RegistrationStatus' }),
            new GridBooleanColumnConfig({
                fieldName: 'isPresent',
                header: 'GMShareholders.IsPresent'
            }),
            new GridDateColumnConfig({
                fieldName: 'checkinTime',
                header: 'GMShareholders.EntryTime',
                format: 'dd.MM. HH:mm:ss'
            }),
            new GridColumnConfig({
                fieldName: 'representedBy',
                header: 'GeneralMeeting.Shareholders.RepresentedBy'
            }),
            new GridNumberColumnConfig({ fieldName: 'id', header: 'Shareholders.Id' }),
            new GridColumnConfig({ fieldName: 'displayName', header: 'Contact.DisplayName' }),
            new GridColumnConfig({ fieldName: 'city', header: 'Address.City' }),
            new GridBooleanColumnConfig({
                fieldName: 'isManagementOrBoardOfDirectors',
                header: 'Shareholders.IsManagementOrBoardOfDirectors'
            }),
            new GridNumberColumnConfig({ fieldName: 'numberOfShares', header: 'GMShareholders.NumberOfShares' }),
            new GridNumberColumnConfig({ fieldName: 'representedVotes', header: 'GMShareholders.RepresentedVotes' }),
            new GridColumnConfig({ fieldName: 'shortSalutation', header: 'Shareholders.ShortSalutation', isHidden: true }),
            new GridColumnConfig({ fieldName: 'deliveryMethodId', header: 'Address.DeliveryMethodName', isHidden: true }),
            new GridColumnConfig({ fieldName: 'zipCode', header: 'Address.ZipCode', isHidden: true }),
            new GridDateColumnConfig({
                fieldName: 'webLoginCreated',
                header: 'GeneralMeeting.Shareholders.WebloginCreatedAt',
                isHidden: true
            }),
            new GridColumnConfig({ fieldName: 'shareholderTypeId', header: 'Shareholders.Type', isHidden: true }),
            new GridColumnConfig({ fieldName: 'ownershipTypeId', header: 'Shareholders.OwnershipType', isHidden: true }),
            new GridColumnConfig({ fieldName: 'languageId', header: 'General.Language', isHidden: true }),
            new GridBooleanColumnConfig({
                fieldName: 'isDepotRepresentative',
                header: 'GMShareholders.IsDepotRepresentative',
                isHidden: true
            }),
            new GridColumnConfig({ fieldName: 'displayName', header: 'Contact.DisplayName', isHidden: true }),
            new GridColumnConfig({ fieldName: 'firstName', header: 'Contact.FirstName', isHidden: true }),
            new GridColumnConfig({ fieldName: 'lastName', header: 'Contact.LastName', isHidden: true }),
            new GridColumnConfig({ fieldName: 'country', header: 'Address.LocationCountryName', isHidden: true }),
            new GridColumnConfig({ fieldName: 'email', header: 'Contact.Email', isHidden: true }),
            new GridColumnConfig({ fieldName: 'correspondenceAddress', header: 'Address.CorrespondenceAddressTitle', isHidden: true }),
            new GridColumnConfig({ fieldName: 'letterSalutation', header: 'Shareholders.LetterSalutation', isHidden: true }),
            new GridNumberColumnConfig({
                fieldName: 'representedNumberOfShares',
                header: 'GMShareholders.RepresentedNumberOfShares',
                isHidden: true
            }),
            new GridNumberColumnConfig({ fieldName: 'votes', header: 'GMShareholders.Votes', isHidden: true }),
            new GridNumberColumnConfig({ fieldName: 'capital', header: 'FactsAndFigures.ShareCapital', isHidden: true }),
            new GridBooleanColumnConfig({ fieldName: 'isProxy', header: 'GMShareholders.IsProxy', isHidden: true }),
            new GridNumberColumnConfig({ fieldName: 'proxyShareholderId', header: 'GMShareholders.ProxyShareholderId', isHidden: true }),
            new GridColumnConfig({ fieldName: 'street', header: 'Address.Street', isHidden: true }),
            new GridColumnConfig({ fieldName: 'streetNumber', header: 'Address.StreetNumber', isHidden: true }),
            new GridDateColumnConfig({ fieldName: 'dateOfBirth', header: 'General.DateOfBirth', isHidden: true }),
            new GridColumnConfig({ fieldName: 'employeeNumber', header: 'Shareholders.EmployeeNumber', isHidden: true }),
            new GridColumnConfig({ fieldName: 'externalId', header: 'Shareholders.ExternalId', isHidden: true }),
            new GridColumnConfig({ fieldName: 'mobileNumber', header: 'Contact.MobileNumber', isHidden: true }),
            new GridBooleanColumnConfig({ fieldName: 'emailConfirmed', header: 'Contact.IsEmailConfirmed', isHidden: true }),
            new GridBooleanColumnConfig({
                fieldName: 'mobileNumberConfirmed',
                header: 'Contact.IsMobileNumberConfirmed',
                isHidden: true
            }),
            new GridColumnConfig({
                fieldName: 'admissionCardNr',
                header: 'GMShareholders.AdmissionCardNr',
                isHidden: true
            }),
            new GridColumnConfig({
                fieldName: 'admissionCardPrintStatus',
                header: 'GMShareholders.CardPrintStatus',
                isHidden: true
            })
        ];
        this.gridConfig = new GridConfig<ListGmShareholderModel>({
            name: 'gm-shareholders',
            typeName: ModelTypes.gmShareholdersSummary,
            resource: this.shareholdersResource,
            pageSize: 10,
            hasNewButton: true,
            hasEditButton: true,
            hasViewButton: true,
            hasRemoveButton: true,
            canExport: true,
            columns
        });
    }
}
